import AsyncSelectV2 from "./AsyncSelectV2";
import InputFloat from "./InputFloat";
import InputInteger from "./InputInteger";
import InputSelect from "./InputSelect";
import InputText from "./InputText";
import SelectList from "./SelectList";
import InputMask from "./InputMask"
import InputDate from "./InputDate";
import SelectManyCheckbox from "./SelectManyCheckbox";

const Input = {
    Text: InputText,
    Select: InputSelect,
    AsyncSelect: AsyncSelectV2,
    SelectList: SelectList,
    Integer: InputInteger,
    Float: InputFloat,
    Mask: InputMask,
    Date: InputDate,
    SelectManyCheckbox
}

export default Input;